import React, { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import { CustomForm } from '@/components/Formik/CustomForm';
import { Toast } from '@/lib/Toast';
import { handleErrorAsync } from '@/utils/handlers';
import { Box, Button, Typography } from '@mui/material';

interface IDefaultResetForm
  extends ComponentPropsWithoutRef<typeof CustomForm> {
  title: string;
  buttonText?: string;
  handleClose: () => void;
  handleCancel: () => void;
}

const DefaultResetForm = ({
  title,
  handleCancel,
  onSubmit,
  buttonText,
  children,
  ...rest
}: PropsWithChildren<IDefaultResetForm>) => {
  return (
    <>
      <CustomForm
        {...rest}
        buttonText={buttonText || 'Salvar alterações'}
        onSubmit={async (values, formikHelpers) => {
          const [_, error] = await handleErrorAsync(async () => {
            await onSubmit(values, formikHelpers);
          });
          if (error) return Toast('error', error.message);
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '8px',
            height: '100%',
          }}
        >
          {title && (
            <Typography
              variant="h5"
              sx={{ opacity: '50%', width: '292px', fontWeight: 700 }}
            >
              {title}
            </Typography>
          )}
          {children}
        </Box>
      </CustomForm>
      <Button
        sx={{ margin: '16px 0 38px' }}
        variant="outlined"
        onClick={handleCancel}
      >
        Cancelar
      </Button>
    </>
  );
};

export default DefaultResetForm;
